// src/utils/tabelaConversaoICV.js

const T = {
  DGV: [
    {min:0,max:5,pt:1},{min:6,max:6,pt:2},{min:7,max:8,pt:3},{min:9,max:9,pt:4},
    {min:10,max:10,pt:5},{min:11,max:11,pt:6},{min:12,max:12,pt:7},
    {min:13,max:14,pt:8},{min:15,max:15,pt:9},{min:16,max:21,pt:10},
  ],
  I:   [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:6},{min:6,max:6,pt:7},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  II:  [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:6},{min:6,max:6,pt:7},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  III: [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:6},{min:6,max:6,pt:7},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  IV:  [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:5},{min:6,max:6,pt:6},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  V:   [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:5},{min:6,max:6,pt:6},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  VI:  [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:7,max:7,pt:8},{min:8,max:8,pt:9},{min:9,max:11,pt:10}],
  VII: [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:5,max:5,pt:6},{min:6,max:6,pt:7},{min:7,max:7,pt:8},{min:8,max:8,pt:9},
        {min:9,max:11,pt:10}],
  VIII:[{min:0,max:3,pt:1},{min:4,max:4,pt:2},{min:5,max:5,pt:4},{min:5,max:5,pt:7},
        {min:6,max:6,pt:8},{min:7,max:7,pt:9},{min:6,max:8,pt:10}],
  IX:  [{min:0,max:1,pt:1},{min:2,max:2,pt:2},{min:3,max:3,pt:3},{min:4,max:4,pt:4},
        {min:7,max:7,pt:9},{min:8,max:8,pt:10}],
  R:   [{min:0,max:14,pt:1},{min:15,max:15,pt:2},{min:16,max:17,pt:3},{min:18,max:19,pt:4},
        {min:20,max:20,pt:5},{min:21,max:22,pt:6},{min:23,max:24,pt:7},{min:25,max:26,pt:8},
        {min:27,max:28,pt:9},{min:29,max:41,pt:10}],
  A:   [{min:0,max:7,pt:1},{min:8,max:8,pt:2},{min:9,max:10,pt:3},{min:11,max:12,pt:4},
        {min:13,max:13,pt:5},{min:14,max:15,pt:6},{min:16,max:16,pt:7},{min:17,max:18,pt:8},
        {min:19,max:20,pt:9},{min:21,max:38,pt:10}],
};

export function converterPT(fator, bruto) {
  const faixas = T[fator];
  if (!faixas) return 0;
  for (const f of faixas) if (bruto >= f.min && bruto <= f.max) return f.pt;
  if (bruto < faixas[0].min) return faixas[0].pt;
  return faixas[faixas.length - 1].pt;
}

export const NOMES_FATORES = {
  DGV: "Disposição Geral para Vendas",
  I: "Compreensão", II: "Adaptabilidade", III: "Autocontrole",
  IV: "Tolerância à Frustração", V: "Combatividade",
  VI: "Domínio", VII: "Segurança", VIII: "Atividade", IX: "Sociabilidade",
  R: "Receptividade (I+II+III+IV)", A: "Agressividade (V+VI+VII+VIII)",
};

// compatibilidade com imports antigos
export const INTERVALOS = T;

export default { converterPT, NOMES_FATORES, INTERVALOS };
